<div class="zhh-betting-limits-alert-container">
	<div class="zhh-betting-limits-alert-header">
		<img
			class="zhh-betting-limits-alert-header-icon"
			obgImageContent="responsible-gaming.betlimit-reached"
			obgImageContentGroup="common"
		/>
		<h1 class="zhh-betting-limits-alert-header-text" [innerHTML]="getTitleText() | translate"></h1>
	</div>
	<div class="zhh-betting-limits-alert-content">
		<p [innerHTML]="getMessageText() | translate"></p>
		<p [innerHTML]="getSubtext() | translate"></p>
	</div>
</div>
